import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

export const EditResourceTypeFormSchema = z.object({
  resourceTypeNumber: z.number().int().optional(), // Business key for edit/upsert
  namespace: z.enum(['cnx', 'frg'], { message: 'Namespace must be cnx or frg' }),
  resourceTypeCategory: z.enum(['artifact', 'component', 'product', 'cloud', 'user-data'], {
    message: 'Category must be one of: artifact, component, product, cloud, user-data'
  }),
  resourceTypeName: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name cannot exceed 100 characters'),
  resourceTypeDescription: z
    .string()
    .max(500, 'Description cannot exceed 500 characters')
    .optional()
    .default(''),
  parentResourceTypes: z.array(z.number()).default([]),
  permissions: z.array(z.string()).default([]),
})

export type EditResourceTypeFormData = z.infer<typeof EditResourceTypeFormSchema>

export function transformToApiRequest(formData: EditResourceTypeFormData) {
  return {
    resourceTypeNumber: formData.resourceTypeNumber, // Business key for upsert
    namespace: formData.namespace,
    resourceTypeCategory: formData.resourceTypeCategory,
    resourceTypeName: formData.resourceTypeName.trim(),
    resourceTypeDescription: formData.resourceTypeDescription?.trim() ?? '',
    parentResourceTypes: formData.parentResourceTypes,
    permissions: formData.permissions,
  }
}
